import { dialogPageTakeoverWidth } from '@atlassian/search-dialog';
export var useIsMobileView = function useIsMobileView() {
  return window.innerWidth <= dialogPageTakeoverWidth;
};